import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  'name': '关于我们 - 韩漫漫画网',
  'description': '韩漫漫画网致力于提供最新高清免费韩国漫画大全，让韩漫爱好者随时随地在线观看热门韩漫。',
  'url': 'https://www.hanmancomic.com/about',
  'mainEntity': {
    '@type': 'Organization',
    'name': '韩漫漫画网',
    'description': '最新高清免费韩国漫画在线阅读平台',
    'url': 'https://www.hanmancomic.com',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  'mainEntity': [
    {
      '@type': 'Question',
      'name': '韩漫漫画网的漫画都是免费的吗？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '是的，韩漫漫画网上所有韩国漫画均为免费在线观看，无需付费订阅。我们致力于为韩漫爱好者提供最新高清的免费韩国漫画资源。',
      },
    },
    {
      '@type': 'Question',
      'name': '韩漫漫画网的更新频率如何？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '我们每天都会更新最新韩漫章节，确保读者能够第一时间阅读到热门韩漫的最新内容。更新及时是我们对读者的承诺。',
      },
    },
    {
      '@type': 'Question',
      'name': '如何在韩漫漫画网找到想看的漫画？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '您可以通过首页的分类导航浏览不同类型的热门韩漫，也可以使用搜索功能直接查找想看的漫画。我们还提供编辑精选和热门推荐，帮助您发现优质韩漫作品。',
      },
    },
    {
      '@type': 'Question',
      'name': '韩漫漫画网是否支持手机观看？',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': '当然支持！韩漫漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您身在何处，都可以随时随地在线观看最新高清免费韩国漫画。',
      },
    },
  ],
};

const stats = [
  { label: '收录漫画', value: '10,000+' },
  { label: '月活跃用户', value: '500万+' },
  { label: '日均更新', value: '200+话' },
  { label: '用户好评率', value: '98.5%' },
];

const reviews = [
  {
    name: '漫画爱好者小陈',
    rating: 5,
    content: '韩漫漫画网真的是我见过最好用的韩漫阅读平台！画面高清，加载速度快，而且还完全免费。更新也很及时，追的几部热门韩漫每天都在更新，太赞了！',
  },
  {
    name: '追漫达人Lily',
    rating: 5,
    content: '用这个网站看韩漫已经一年多了，资源非常丰富，分类也很清晰。画质很高清，阅读体验超级棒。推荐给了身边很多朋友，大家都说好用！',
  },
  {
    name: '二次元小王',
    rating: 5,
    content: '作为一个韩漫重度用户，试过很多平台，韩漫漫画网是我最满意的。没有烦人的广告，漫画种类齐全，而且界面设计简洁大方，阅读起来很舒服。',
  },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 韩漫漫画网_最新高清免费韩国漫画平台';
  }, []);

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(aboutSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />

            {/* Brand Introduction */}
            <section className="mb-14">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
                关于韩漫漫画网
              </h1>
              <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
                <p className="text-foreground-700 leading-relaxed mb-4">
                  <strong>韩漫漫画网</strong>是一个专注于<strong>最新高清免费韩国漫画</strong>的在线阅读平台。我们致力于为广大韩漫爱好者提供最全面、最优质的韩国漫画资源，让每一位读者都能享受畅快淋漓的观漫体验。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  自成立以来，我们始终秉持&ldquo;画面精美、更新及时、完全免费&rdquo;的服务理念，精心筛选和收录各类<strong>热门韩漫</strong>作品。从浪漫恋爱到热血动作，从奇幻冒险到悬疑推理，从搞笑日常到深刻剧情，涵盖丰富的漫画类型，满足不同读者的口味需求。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  我们深知每一位韩漫爱好者对于画质和更新速度的追求。因此，韩漫漫画网配备了高清漫画阅读系统，并提供每日更新的最新章节，确保读者能够随时随地享受<strong>在线观看</strong>韩漫的乐趣。
                </p>
              </div>
            </section>

            {/* Stats */}
            <section className="mb-14">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70"
                  >
                    <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                      {stat.value}
                    </p>
                    <p className="text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Reviews */}
            <section className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {reviews.map((review) => (
                  <div
                    key={review.name}
                    className="bg-background-100 rounded-lg border border-background-200/70 p-5"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      &ldquo;{review.content}&rdquo;
                    </p>
                    <p className="text-xs text-foreground-500 font-medium">
                      — {review.name}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* FAQ */}
            <section className="mb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqSchema.mainEntity.map((item, index) => (
                  <details
                    key={index}
                    className="bg-background-100 rounded-lg border border-background-200/70 group"
                  >
                    <summary className="px-5 py-4 cursor-pointer flex items-center justify-between text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors">
                      <span>{item.name}</span>
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {item.acceptedAnswer.text}
                    </div>
                  </details>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section className="pb-14">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
                联系我们
              </h2>
              <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-mail-line"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800 mb-1">电子邮箱</p>
                      <p className="text-sm text-foreground-500">contact@hanmancomic.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-customer-service-2-line"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800 mb-1">在线客服</p>
                      <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800 mb-1">办公地址</p>
                      <p className="text-sm text-foreground-500">韩国首尔特别市江南区</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}